import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import logo from './../../images/logo.png';
import NavBar from './NavBar';

const Header = props => {
  return (
    <Container fluid className="w-100 header">
      <div></div>
      <div className="d-flex justify-content-between text-center w-100">
        <Link to="/">
          <img src={logo} alt="logo" />
        </Link>
        <NavBar />
      </div>
    </Container>
  );
};

export default Header;
